import React from 'react';

const Contact = () => {
  return (
    <section className="pb_80 pt_80">
      <div className="container">
            <div className="row d-flex justify-content-center ">
                <div className="col-md-4">
                    <div className="contact-details">
                    <h2>CONTACT US</h2>
                    <p>For any queries, students can reach out to the Chettinad Health City Campus at the contact details below.</p>

                    <div className="contact-info-item">
                        <i className="fa fa-envelope-o contact-icon"></i>
                        <span>
                        <a href="mailto:cgl.languages@chettinadhealthcity.com" className="email-link">
                            cgl.languages@chettinadhealthcity.com
                        </a>
                        </span>
                    </div>
                    <div className="contact-info-item">
                        <i className="fa fa-phone contact-icon"></i>
                        <span>044 4741 1056</span>
                    </div>
                    <div className="contact-info-item">
                        <i className="fa fa-map-marker"></i>
                        <span>Chettinad Health City, Kelambakkam, Chennai</span>
                    </div>



                    </div>
                </div>

                <div className="col-md-4">
                    <div className="map-container">
                    <iframe 
                        src="https://www.google.com/maps/d/embed?mid=1SvC_i9HR8u4ihVxEP6kmxEztA2N_7fc&ehbc=2E312F&noprof=1" 
                        style={{ width: '100%' }}
                        title="Chettinad Health City Location"
                        allowFullScreen

                    ></iframe>
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
};

export default Contact;